module.exports = __webpack_public_path__ + "img/rak_middle.2dda9fb2.png";